import {
  PlantDetailDTO,
  RoomDTO,
  RoomObjectDTO,
  RoomObjectType,
} from '@/../client-generator/generated-clients/plants';
import { Options } from 'vue-class-component';
import { mapState } from 'vuex';
import CommandWizardStep from '../CommandWizardStep';
import RoomAndRoomObjects from './RoomAndRoomObjects/RoomAndRoomObjects.vue';

@Options({
  name: 'CommandWizardAssignRoomObjects',
  components: {
    RoomAndRoomObjects,
  },
  computed: {
    ...mapState(['selectedPlantId', 'currentPlant']),
  },
  watch: {
    selectedRoomObjectsCount() {
      this.validateNextEnabled();
    },
  },
})
export default class CommandWizardAssignRoomObjects extends CommandWizardStep {
  selectedPlantId!: number;
  currentPlant!: PlantDetailDTO | null;
  RoomObjectType = RoomObjectType;

  created() {
    this.validateNextEnabled();
  }

  get subTitle() {
    if (this.commandGroup.roomObjectType == RoomObjectType.Light){
      return this.$t('AppResource.SelectLightsDescription')
    }else{
      return this.$t('AppResource.SelectShuttersDescription')
    }
  }

  get selectedRoomObjects() {
    const _return =
      this.commandGroup.rooms?.flatMap((r) => {
        return r.roomObjects?.map((o) => o.id);
      }) || [];
    return _return;
  }

  get contextualRoomObjects() {
    return (
      this.currentPlant?.rooms?.filter((r) =>
        r?.roomObjects?.some((o) => o.type === this.commandGroup.roomObjectType)
      ) || []
    );
  }

  get selectedRoomObjectsCount() {
    return this.selectedRoomObjects.length;
  }

  doToggleRoomObject(obj: { room: RoomDTO; roomObject: RoomObjectDTO }) {
    const selRoomIndex = this.commandGroup.rooms?.findIndex(
      (r) => r.id === obj.room.id
    );
    if (selRoomIndex !== undefined && selRoomIndex >= 0) {
      const selRoom =
        this.commandGroup.rooms && this.commandGroup.rooms[selRoomIndex];
      if (!selRoom) return;
      const index = selRoom.roomObjects?.findIndex(
        (o) => o.id === obj.roomObject.id
      );
      if (index !== undefined && index >= 0) {
        selRoom.roomObjects = selRoom.roomObjects?.filter(
          (o) => o.id !== obj.roomObject.id
        );
        if (selRoom.roomObjects && selRoom.roomObjects.length === 0) {
          this.commandGroup.rooms = this.commandGroup.rooms?.filter(
            (r) => r.id !== selRoom.id
          );
        }
      } else {
        selRoom.roomObjects = [...(selRoom.roomObjects || []), obj.roomObject];
      }
    } else {
      obj.room.roomObjects = [obj.roomObject];
      this.commandGroup.rooms = [...(this.commandGroup.rooms || []), obj.room];
    }
  }

  validateNextEnabled() {
    this.nextEnabled = this.selectedRoomObjectsCount > 0;
  }
}
